const CART_KEY = "CART_KEYS_2";
const PRODUCT_KEY = "product";
const STORE_KEY = "store";
const BAG_KEY = "BAG_KEY";

export { CART_KEY, STORE_KEY, PRODUCT_KEY, BAG_KEY };
